import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function OTFTUseCase() {
  return (
    <>
    <section
      id="otfts"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">
	  
        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            OTFTs (Organic Thin-Film Transistors)
          </h1>
          <p className="text-slate-300 space-y-2">
            OTFTs are field-effect transistors that use organic semiconductors as their active channel layer.
            They offer a flexible, lightweight, and low-cost alternative to traditional silicon-based transistors — ideal for printable electronics, flexible displays, sensors, and RF-ID tags.
            Unlike rigid silicon devices, OTFTs can be fabricated on plastic substrates using solution-based processes, paving the way for roll-to-roll electronics and large-area circuitry.

            <br /><br />

            Achieving high performance in OTFTs requires careful design of the organic semiconductor to optimise charge carrier mobility, air stability, and thin-film morphology.
            Molecular packing and intermolecular orbital overlap strongly influence charge transport; thus, understanding and predicting solid-state structure is critical to device function.
            Design efforts often focus on p-type (hole-conducting), n-type (electron-conducting), or ambipolar materials — with increasing demand for materials stable under ambient conditions.

            <br /><br />

            OTFTs are a foundational technology in the shift toward flexible and wearable electronics, enabling circuitry that bends, folds, and integrates directly onto physical surfaces.
          </p>
        </div>

        {/* How Apoello Helps */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>
              Screen small-molecule semiconductors for HOMO/LUMO levels, orbital delocalisation, and reorganisation energy.
            </li>
            <li>
              Predict charge carrier mobility and perform solid-state packing analysis.
            </li>
            <li>
              Identify stable candidates with favourable energy level alignment for p- or n-type operation.
            </li>
            <li>
              Order potential OTFT materials directly.
            </li>
          </ul>
        </div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            OTFT R&D is challenged by the complex interplay between molecular design and solid-state behaviour.
            DiaDEM™ accelerates discovery by connecting molecular properties, predicted packing, and device-relevant transport metrics — allowing rapid down-selection before synthesis begins.
            This reduces wasted effort and shortens the path from concept to functional device.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
